import React from 'react';
import { ShieldX, Lock, AlertTriangle, Globe } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_467e7424-249d-4984-8afc-452f42a05c3c/artifacts/6ivxke97_Logo.png';

const AccessDenied = ({ ipAddress }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-red-900/20 to-slate-900 relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-red-600/10 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-orange-600/10 via-transparent to-transparent"></div>
      </div>

      {/* Grid Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:50px_50px]"></div>

      {/* Floating Security Icons */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-float opacity-10"
            style={{
              left: `${10 + Math.random() * 80}%`,
              top: `${10 + Math.random() * 80}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${8 + Math.random() * 8}s`,
            }}
          >
            <Lock className="w-8 h-8 text-red-400" />
          </div>
        ))}
      </div>

      <div className="relative z-10 max-w-lg mx-auto px-6 text-center">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src={LOGO_URL} 
            alt="Creative Infotech" 
            className="w-20 h-20 object-contain mx-auto opacity-50 grayscale"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>

        {/* Shield Icon */}
        <div className="relative mb-8">
          <div className="w-32 h-32 mx-auto bg-gradient-to-br from-red-500/20 to-orange-500/20 rounded-full flex items-center justify-center border border-red-500/30 shadow-2xl shadow-red-500/20">
            <div className="w-24 h-24 bg-gradient-to-br from-red-500/30 to-orange-500/30 rounded-full flex items-center justify-center">
              <ShieldX className="w-12 h-12 text-red-400" strokeWidth={1.5} />
            </div>
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-red-500 rounded-full flex items-center justify-center animate-pulse">
            <AlertTriangle className="w-4 h-4 text-white" />
          </div>
        </div>

        {/* Main Message */}
        <h1 className="text-4xl font-bold text-white mb-4">
          Access <span className="text-red-400">Restricted</span>
        </h1>
        
        <p className="text-xl text-slate-400 mb-8">
          Your network is not authorized to access this application.
        </p>

        {/* IP Info Card */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 p-6 mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Globe className="w-5 h-5 text-slate-400" />
            <span className="text-slate-400">Your IP Address</span>
          </div>
          <div className="bg-slate-800/50 rounded-xl py-3 px-6 inline-block">
            <code className="text-lg font-mono text-red-400">{ipAddress || 'Unknown'}</code>
          </div>
        </div>

        {/* Info Message */}
        <div className="bg-gradient-to-r from-amber-500/10 to-orange-500/10 rounded-xl border border-amber-500/20 p-4 mb-8">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-300 text-left">
              This CRM system is protected by IP-based access control. 
              If you believe you should have access, please contact your system administrator 
              to whitelist your IP address.
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-sm text-slate-500">
          Creative Infotech • Enterprise CRM Platform
        </p>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }
        .animate-float {
          animation: float 10s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default AccessDenied;
